import React, { useState, Component } from 'react';
import { MessageSquareIcon, XIcon, SendIcon } from 'lucide-react';
const FeedbackSection = () => {
  const [showFeedbackForm, setShowFeedbackForm] = useState(false);
  const [feedbackText, setFeedbackText] = useState('');
  const handleOpenFeedbackForm = () => {
    setShowFeedbackForm(true);
  };
  const handleCloseFeedbackForm = () => {
    setShowFeedbackForm(false);
    setFeedbackText('');
  };
  const handleSubmit = e => {
    e.preventDefault();
    // Create mailto link with the feedback in the body
    const mailtoLink = `mailto:info@joinemigo.com?subject=Feedback for Emigo&body=${encodeURIComponent(feedbackText)}`;
    // Open email client with the feedback
    window.location.href = mailtoLink;
    // Close the form after submission
    handleCloseFeedbackForm();
  };
  return <section className="py-16 md:py-24 bg-white border-t border-gray-200" data-id="element-167">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-168">
        <h2 className="text-3xl md:text-4xl font-semibold text-gray-900 mb-4" style={{
        fontFamily: "'DM Serif Display', serif"
      }} data-id="element-169">
          Help Us Improve Emigo
        </h2>
        <p className="mt-4 text-xl text-gray-600 mb-8" data-id="element-170">
          Please tell us how Emigo can better assist you! Your feedback helps us
          create a better emotional intelligence companion for everyone.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-16" data-id="element-171">
          <button className="inline-flex items-center px-6 py-3 rounded-full bg-[#E87B5C] text-white font-medium hover:bg-[#D16A4A] transition-all shadow-sm hover:shadow-md" onClick={handleOpenFeedbackForm} data-id="element-172">
            <MessageSquareIcon className="w-5 h-5 mr-2" data-id="element-173" />
            Give Feedback
          </button>
        </div>
      </div>
      {/* Feedback Form Popup */}
      {showFeedbackForm && <div className="fixed inset-0 z-50 overflow-y-auto flex items-center justify-center p-4 bg-black bg-opacity-50" data-id="element-174">
          <div className="bg-white rounded-xl shadow-xl max-w-md w-full p-6 animate-popup" data-id="element-175">
            <div className="flex justify-between items-center mb-6" data-id="element-176">
              <h2 className="text-xl font-bold text-gray-800" data-id="element-177">
                Share Your Feedback
              </h2>
              <button onClick={handleCloseFeedbackForm} className="text-gray-500 hover:text-gray-700 transition-colors" data-id="element-178">
                <XIcon className="w-5 h-5" data-id="element-179" />
              </button>
            </div>
            <form onSubmit={handleSubmit} className="space-y-4" data-id="element-180">
              <div data-id="element-181">
                <label htmlFor="feedback" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-182">
                  Your Feedback
                </label>
                <textarea id="feedback" value={feedbackText} onChange={e => setFeedbackText(e.target.value)} rows={6} className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-[#E87B5C] focus:border-[#E87B5C] text-gray-800" placeholder="How can we improve Emigo to better serve your needs?" required data-id="element-183"></textarea>
              </div>
              <div className="flex justify-end space-x-3 pt-2" data-id="element-184">
                <button type="button" onClick={handleCloseFeedbackForm} className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 transition-colors" data-id="element-185">
                  Cancel
                </button>
                <button type="submit" className="px-4 py-2 bg-gradient-to-r from-[#E87B5C] to-[#FFD700] text-white rounded-md hover:opacity-90 transition-colors flex items-center" data-id="element-186">
                  Submit to info@joinemigo.com
                  <SendIcon className="ml-2 h-4 w-4" data-id="element-187" />
                </button>
              </div>
            </form>
          </div>
        </div>}
    </section>;
};
export default FeedbackSection;